export const isAdminDomain = process.env.REACT_APP_DOMAIN === "ADMIN";
